<span>
    {{params.value | number}}
</span>
<span class="info" (mouseover)="openDialog($event)" *ngIf="params.value && !isInboundQty && !params.isDuplicateSkus" (mouseout)="closeDialog($event)">
    <i class="fas fa-info-circle"></i> 
</span>
<span class="info info_inbound" *ngIf="params.value && isInboundQty && !params.isDuplicateSkus" (click)="openInboundDialog($event)">
    <i class="fas fa-chevron-down"></i>
</span>
<span class="info"*ngIf="params.value && params.isDuplicateSkus && params.data.DuplicateSkus > 0">
    <i class="fal fa-exclamation-triangle icon-info ms-2" [matTooltip]="duplicateSkus"></i>
  </span>
